import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ConfirmationDialog = ({ open, onClose, onConfirm, message }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          fontSize: { xs: "1.2rem", sm: "1.5rem" },
        }}
      >
        {t("admin.confirmation.title")}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          {message}
        </Typography>
      </DialogContent>
      {loading ? (
        <Box display="flex" justifyContent="flex-end" p={1}>
          <CircularProgress size={20} />
        </Box>
      ) : (
        <DialogActions
          sx={{
            justifyContent: "center",
            padding: { xs: "12px", sm: "16px 24px" },
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
          }}
        >
          <Button
            onClick={onClose}
            color="secondary"
            sx={{ borderRadius: "8px", width: { xs: "100%", sm: "auto" } }}
          >
            {t("admin.confirmation.cancel")}
          </Button>

          <Button
            onClick={async () => {
              setLoading(true);
              await onConfirm();
              setLoading(false);
            }}
            color="error"
            sx={{
              color: "red",
              borderRadius: "8px",
              width: { xs: "100%", sm: "auto" },
              "&:hover": { backgroundColor: "red", color: "#fff" },
            }}
          >
            {t("admin.confirmation.ok")}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired, // Dialog visibility state
  onClose: PropTypes.func.isRequired, // Function to close the dialog
  onConfirm: PropTypes.func.isRequired, // Function triggered on confirmation
  message: PropTypes.string,
};

export default ConfirmationDialog;
